module.exports = __webpack_public_path__ + "static/media/img_panel_opportunity1.2edcb993.jpg";